export default "__VITE_ASSET__6fc00385__"